import * as React from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';

import { clearPhone } from './phone';
import { selectAnalyticsUser } from '../../../selectors/analytics';
import { selectUserPhone } from '../../../selectors/user';
import { trackRequirementsFill } from '../../../utils/analytics';

const DEBOUNCE_DELAY = 300;

export function useRequirementsFillAnalytics() {
  const isSentRef = React.useRef<boolean>(false);
  const analyticsUser = useSelector(selectAnalyticsUser);
  const userPhone = useSelector(selectUserPhone);

  const requirementsChangeHandler = React.useCallback(
    (inputPhone: string) => {
      if (!isSentRef.current) {
        trackRequirementsFill(userPhone, clearPhone(inputPhone), analyticsUser);
        isSentRef.current = true;
      }
    },
    [analyticsUser, userPhone],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(debounce(DEBOUNCE_DELAY, requirementsChangeHandler), []);
}
